import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_kana_list = _resolveComponent("kana-list")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1)),
    _createElementVNode("div", null, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('features.nursery-web-staff-attendance-management')), 1)
    ]),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              indeterminate: "",
              color: "primary"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
      width: "620px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedUser ? (_ctx.selectedUser.lastName + ' ' + _ctx.selectedUser.firstName) : ''), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, { class: "py-8" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "pt-8" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              disabled: !_ctx.shouldAttendButtonEnabled,
                              color: "primary",
                              block: "",
                              style: {"height":"18vh","font-size":"1.8rem"},
                              onClick: _ctx.attend,
                              variant: "flat",
                              class: "custom-disabled-btn"
                            }, {
                              default: _withCtx(() => [
                                _cache[2] || (_cache[2] = _createTextVNode("Clock In", -1)),
                                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.attendedTime), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              disabled: !_ctx.shouldLeftButtonEnabled || _ctx.shouldAttendButtonEnabled,
                              color: "secondary",
                              block: "",
                              style: {"height":"18vh","font-size":"1.8rem"},
                              onClick: _ctx.left,
                              variant: "flat",
                              class: "custom-disabled-btn"
                            }, {
                              default: _withCtx(() => [
                                _cache[4] || (_cache[4] = _createTextVNode("Clock Out", -1)),
                                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.leftTime), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, [
                  (_ctx.isUpdating)
                    ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                        key: 0,
                        indeterminate: "",
                        color: "primary",
                        class: "my-8"
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[0] || (_cache[0] = () => _ctx.dialog = false),
                  variant: "text",
                  color: "grey"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_container, {
      fluid: "",
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { style: {"height":"100vh"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "10",
              "align-self": "center",
              style: {"height":"100vh"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_kana_list, {
                  kanaArray: _ctx.kanaList,
                  onKanaClicked: _ctx.clickKana
                }, null, 8, ["kanaArray", "onKanaClicked"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  nav: "",
                  "bg-color": "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_subheader, { class: "text-white font-weight-bold" }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("Staff", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider, {
                      color: "white",
                      thickness: "1",
                      class: "opacity-100"
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffList, (item) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: item.userId,
                        onClick: ($event: any) => (_ctx.clickStaff(item)),
                        link: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "text-white font-weight-bold" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.lastName + ' ' + item.firstName) + " ", 1),
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode("mdi-chevron-right", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}